import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Component that scrolls to the top of the page whenever the route changes.
 * Must be placed inside BrowserRouter.
 *
 * Uses both immediate scroll and a delayed scroll to handle lazy-loaded content.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Immediate scroll
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    // Delayed scroll to handle lazy-loaded content
    // This ensures scroll happens after Suspense content is mounted
    const timeoutId = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};
